import { Injectable } from "@angular/core";
import { EndInputs } from "../link-device-model";
import { EndTransmission, MuxDemux, Port, Transmission } from "../../../../links.model";

/**
 * Serviço responsável por tratar as transmissões de um END de links.
 */
@Injectable({
    providedIn: "root"
})
export class LinkDeviceEndTransmissionService {

    public updateTransmissionLinked(endInputs: EndInputs, end: MuxDemux | Port, transmissionValue: Transmission) {
        const transmission = endInputs.endTransmissions
            .find(transmission => transmission.transmission === transmissionValue);

        if (transmission.transmission === Transmission.TX) {
            transmission.linked = end.txTransmission.linked;
        } else {
            transmission.linked = end.rxTransmission.linked;
        }
    }

    public isTransmissionLinked(isDwdm: boolean, isMuxSelected: boolean, mux: MuxDemux, port: Port,
            transmission: EndTransmission<Transmission>): boolean {
        const end = isMuxSelected ? mux : port;

        if (!isDwdm || !transmission || !end) {
            return false;
        }

        if (transmission.transmission === Transmission.RX) {
            return this.isLinked(end.rxTransmission, transmission);
        }

        return this.isLinked(end.txTransmission, transmission);
    }

    private isLinked(selectedEndTransmission: EndTransmission<Transmission>,
            transmission: EndTransmission<Transmission>): boolean {
        return selectedEndTransmission?.transmission === transmission.transmission && selectedEndTransmission.linked;
    }
}
